import React, { useReducer } from 'react';
import {
    withStyles,
    Grid,
    ButtonBase,
    Typography,
    ListItem,
    Avatar,
    Divider,
} from '@material-ui/core';
import IMApp from '../../net/IMApp';

const ICONS = [
    require('../../images/icons/icon_txl.png'),
    require('../../images/icons/icon_qunliao.png'),
    require('../../images/icons/icon_tjhy.png')
];

class ChatBookItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: 0
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onListItemClick = () => {
        this.props.onClick && this.props.onClick();
    }

    onRefuseClick = () => {
        console.log('onRefuseClick');
    }

    onConfirmClick = async (item) => {
        let res = await IMApp.applyFriend(item.uid, 1);
        if (res.result == 1) {
            console.log(res);
            this.setState({ status: 1 });
        }
    }

    render() {
        const { classes, data } = this.props;
        const { status } = this.state;
        return (
            <ListItem disableRipple button onClick={() => this._onListItemClick()} className={classes.root}>
                <Grid container direction='row' alignItems='center'>
                    <Grid container direction='row' alignItems='center' justifyContent='space-between'>
                        <Grid container direction='row' alignItems='center' style={{ flex: 1, paddingLeft: 8 }}>
                            <Avatar src={data.headurl} className={classes.menuIcon} />
                            <Grid style={{ marginLeft: 8 }}>
                                <Grid container direction='row' alignItems='center' >
                                    <Typography style={{ fontSize: 14, color: '#0D0D0D' }}>{data.nickname}</Typography>
                                    <Typography style={{ fontSize: 9, color: '#878787', marginLeft: 8 }}>{data.time}</Typography>
                                </Grid>
                                <Typography style={{ fontSize: 9, color: '#878787', marginTop: 4 }}>{data.desc}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1, paddingRight: 24 }}>
                            {/* { <ButtonBase className={classes.refuseButton} onClick={() => this.onRefuseClick()}>拒绝</ButtonBase>} */}
                            {status == 1 && <Typography style={{ fontSize: 14, color: '#878787' }}>已同意</Typography>}
                            {status == 0 && <ButtonBase className={classes.confirmButton} onClick={() => this.onConfirmClick(data)}>同意</ButtonBase>}
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
        );
    }
}
export default withStyles((theme) => ({
    root: {
        margin: theme.spacing(1, 0, 1, 0),
        padding: 0,
    },
    menuIcon: {
        width: 40,
        height: 40,
    },
    refuseButton: {
        backgroundColor: '#D11818',
        width: 48,
        height: 24,
        borderRadius: 4,
        color: '#FFF',
        fontSize: 12,
    },
    confirmButton: {
        backgroundColor: '#02C40F',
        width: 48,
        height: 24,
        borderRadius: 4,
        marginLeft: 8,
        color: '#FFF',
        fontSize: 12,
    }
}))(ChatBookItem);
